module.exports = __webpack_public_path__ + "static/media/Albion Building Consultant Inc. Notice of Proposal.753bc3fd.pdf";